class CardSwatch extends HTMLElement {
  static cache = new Map(); 

  constructor() {
    super();
    this.url = this.getAttribute("data-url");
  }

  connectedCallback() {
    this.addEventListener("click", async (e) => {
      e.preventDefault();

      let htmlDoc;

      if (CardSwatch.cache.has(this.url)) {
        htmlDoc = CardSwatch.cache.get(this.url);
      } else {
        const res = await fetch(this.url, { cache: "no-cache" });
        const text = await res.text();
        
        htmlDoc = new DOMParser().parseFromString(text, "text/html");

        CardSwatch.cache.set(this.url, htmlDoc);
      }

      const productContainer = this.closest("product-card");
      if(productContainer){
         const newCard = htmlDoc.querySelector("product-card");
         if (productContainer && newCard) {
           productContainer.outerHTML = newCard.outerHTML;
         }
      }
      else{
        const recentContainer = this.closest(".recently_view_item")
        const newCard = htmlDoc.querySelector(".recently_view_item");
        recentContainer.outerHTML = newCard.outerHTML;
      }

    });
  }
}

if (!customElements.get("card-swatch")) customElements.define("card-swatch", CardSwatch);